module.exports = __webpack_public_path__ + "static/media/icone-whatsapp.d95e8721.png";